<div class="c-card c-content c-content--xxl">
	<div class="o-grid o-grid--center-h">
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-60@md-and-up o-grid__cell--w-40@lg-and-up u-no-p">
			<form name="vm.form" class="c-form" #mainForm="ngForm">
				<fieldset *ngIf="vm.user?.personalCode">
					<legend class="c-form__label c-form__label--light">{{ 'Symptom_Check.Patient.Intro' | translate }}</legend>
					<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && selfTest.invalid}">
						<label class="c-radio">
							<input type="radio" name="selfTest" [(ngModel)]="vm.interview.selfTest" [value]="true" #selfTest="ngModel" required>
							<span id="forMySelfLabel" *ngIf="!vm.isRecordTicketForPerson">{{ 'Symptom_Check.Patient.For_Myself' | translate }}</span>
							<span id="asOtherPersonLabel" *ngIf="vm.isRecordTicketForPerson">{{ 'Symptom_Check.Patient.For_Patient' | translate }}</span>
						</label>
					</div>
					<div class="c-form__group u-osb-md" [ngClass]="{'c-form__group--error': vm.submitted && selfTest.invalid}" *ngIf="vm.params.type !== 'pre-visit'">
						<label class="c-radio">
							<input type="radio" name="selfTest" [(ngModel)]="vm.interview.selfTest" [value]="false" #selfTest="ngModel" required>
							<span id="forOtherPersonLabel">{{ 'Symptom_Check.Patient.For_Third_Party' | translate }}</span>
						</label>
					</div>
				</fieldset>
				<div *ngIf="vm.interview.selfTest===false || !vm.user?.personalCode">
					<p class="c-text c-text--gray u-osb-md">{{ 'Symptom_Check.Patient.Patient_Intro' | translate }}</p>
					<div class="c-form__group u-osb-md" [ngClass]="{'c-form__group--error': vm.birthDateInvalid }">
					    <label class="c-form__label c-form__label c-text--gray">
					        {{ 'Symptom_Check.Patient.Birth_Date' | translate }}
					    </label>
					    <div *ngIf="!vm.isProcessing">
					        <input-datepicker-new id="birthDate"
					                          name="birthDate"
					                          [(model)]="vm.birthDate"
					                          [startDate]="vm.birthDate"
					                          [minDate]="vm.minDate"
					                          [hasTimepicker]="false"
					                          [hasCalendarIcon]="true"
					                          [hasDropdowns]="true"
					                          [isSingleDate]="true">
					        </input-datepicker-new>
					    </div>
					    <item-form-error
					            *ngIf="vm.submitted && vm.birthDateInvalid"
					            [fieldName]="'Symptom_Check.Patient.Birth_Date' | translate"
					            [error]="{'required':true}"></item-form-error>
					</div>
					<fieldset>
						<legend class="c-form__label c-form__label--light">{{ 'Symptom_Check.Patient.Patient_Sex' | translate }}</legend>
						<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && sex.invalid}">
							<label class="c-radio">
								<input type="radio" name="sex" [(ngModel)]="vm.interview.sex" [value]="'male'" #sex="ngModel" required>
								<span id="genderMaleLabel">{{ 'Common.Male' | translate }}</span>
							</label>
						</div>
						<div class="c-form__group u-osb-md" [ngClass]="{'c-form__group--error': vm.submitted && sex.invalid}">
							<label class="c-radio">
								<input type="radio" name="sex" [(ngModel)]="vm.interview.sex" [value]="'female'" #sex="ngModel" required>
								<span id="genderFemaleLabel">{{ 'Common.Female' | translate }}</span>
							</label>
						</div>
						<p class="c-text c-text--s3 c-text--sm u-ost-sm" *ngIf="vm.submitted && sex.invalid">
							<span>{{ 'Symptom_Check.Patient.Patient_Sex_Error_Required' | translate }}</span>
						</p>
					</fieldset>
				</div>
			</form>
		</div>
	</div>
	<div class="o-grid u-ost-md">
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
			<button id="backButton" class="c-button c-button--link c-button--fit c-button--lg" type="button" (click)="vm.handleBack()">{{ 'Common.Back' | translate }}</button>
		</div>
		<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
			<button id="submitButton" class="c-button c-button--s1 c-button--fit c-button--lg" type="button" (click)="vm.handleSubmit(mainForm)">{{ 'Common.Next' | translate }}</button>
		</div>
	</div>
</div>
